module.exports = __webpack_public_path__ + "img/image02_sp.48d1646a.jpg";